import { useQuery } from '@tanstack/react-query'
import { IDailyStatisticsState } from 'models/ICattlesData'
import CattlesApiService from 'services/cattlesApiServices'

export const useGroupDailyStatistics = (groupId: number, enabled = true) =>
	useQuery<IDailyStatisticsState>({
		queryKey: ['groupDailyStatistics', groupId],
		queryFn: async () => {
			const response = await CattlesApiService.getDailyStatistics(groupId)
			return response.data
		},
		enabled,
		retry: false,
		staleTime: 1000 * 60 * 5,
	})
